<template>
  <div class="stream-status-container align-self-center text-center">
    <div data-v-e5fd3402="" data-v-02b69d06="" class="loaderLayout">
      <div data-v-e5fd3402="" class="loaderSecondaryLayout">
        <div data-v-e5fd3402="" class="loaderPosition">
          <div data-v-e5fd3402="" class="vue-loaders ball-spin-fade-loader" style="transform: scale(0.5)">
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
            <div style="background-color: rgb(30, 143, 225)"></div>
          </div>
        </div>
        <div data-v-e5fd3402="" class="loadingText">Loading <slot name="percentage"></slot></div>
      </div>
    </div>
  </div>
</template>
<script>
/* import 'vue-loaders/dist/vue-loaders.css'; */
export default {
  name: "bars",
  props: {
    color: {
      type: String,
      default: "#000"
    },
    height: {
      type: Number,
      default: 40
    },
    width: {
      type: Number,
      default: 40
    }
  }
};
</script>

<style scoped></style>
